import AvatarEditPopup from './AvatarEditPopup';
import AvatarEditPopupContainer from './AvatarEditPopup.container';

export default AvatarEditPopupContainer(AvatarEditPopup);
